<!--
  No wrapper div around mat-dialog-* elements. The global panel styles make
  Material's dialog surface the flex column, with mat-dialog-content as the
  only scroll region and mat-dialog-actions kept outside that scroll area.
-->
<h2 class="whats-new__title" mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="whats-new__content">
  <div class="whats-new__item" *ngFor="let item of data.items">
    <mat-icon class="whats-new__icon" fontSet="material-symbols-outlined" aria-hidden="true">{{ item.icon }}</mat-icon>
    <div class="whats-new__text">
      <div class="whats-new__item-title">{{ item.title }}</div>
      <div class="whats-new__item-desc">{{ item.description }}</div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="whats-new__actions" align="center">
  <button mat-stroked-button color="primary" class="whats-new__learn-more" (click)="onLearnMore()">Learn more</button>
  <button mat-raised-button color="primary" (click)="onGotIt()" cdkFocusInitial>Got it</button>
</mat-dialog-actions>
